import Dashboard from "../Components/Dashboard/dashboard";
import UploadAssets from "../Components/UploadAssets/UploadAssets";
import DeployPage from "../Components/DeployPage/deploypage";
import Details from "../Components/Details/details";
import Tasklist from "../Components/TaskList/tasklist";
import SopPage from "../Components/SOP/soppage";
import Videopage from "../Components/video/videoPage";
import QuizPage from "../Components/Quiz/QuizPage";
import Channels from "../Components/Channels/channels";
import ChannelsSelect from "../Components/Channels/channelselect";
import ModuleTabs from "../Components/ModuleTabs";
import Languages from "../Components/Languages/Languages";
import PassingCriteria from "../Components/PassingCriteria/PassingCriteria";
import ENVDashboard from "../Components/ENVPages/ENVDashboard";
import ENVTabs from "../Components/ENVPages/ENVTabs";
import ENVDetails from "../Components/ENVPages/ENVDetails";
import ENVAssets from "../Components/ENVPages/ENVAssets";
import ENVContent from "../Components/ENVPages/ENVContent";
import AssetDashboard from "../Components/AssetsPages/AssetsDashboard";
import AssetDetails from "../Components/AssetsPages/AssetDetails";
import AssetsTabs from "../Components/AssetsPages/AssetsTabs";
import AssetsChildDashboard from "../Components/AssetsPages/AssetsChildDashboard";
import LMSDashboard from "../Components/2DLMS/Dashboard";
import LMSDetailsPage from "../Components/2DLMS/LMSDetailsPage.js";
import SubSectionDetails from "../Components/2DLMS/SubSections/SubSectionDetails.js";
import CategoryMain from "../Components/Categories/CategoryMain.js";
import ScenarioBuilder from "../Components/ENVPages/ScenarioBuilder.js";
import ArList from "../Components/AR/ArList.js";
import ARTabs from "../Components/AR/ARTabs.js";
import AddDynamicModule from "../Components/ENVPages/components/AddDynamicModule.js";
import ARModuleDetails from "../Components/AR/ARModuleDetails.js";
import {
    CONTENT_XR,
    CONTENT_XR_QUIZ,
    CONTENT_XR_SOPS,
    CONTENT_XR_PASSING,
    CONTENT_XR_ASSETS,
    CONTENT_XR_TASKS,
    CONTENT_ENVIRONMENT,
    CONTENT_ENVIRONMENT_CREATE,
    CONTENT_DYNAMIC_CONTENT,
    CONTENT_CATEGORY,
    CONTENT_AR,
    CONTENT_2D,
    CONTENT_3D,
    CONTENT_AR_CREATE,
} from "../constant/Permissions.js";

const routesList = [
    {
        path: "/dashboard/xr",
        element: Dashboard,
        permissions: [CONTENT_XR]
    },
    {
        path: "/dashboard/xr/details/:uuid",
        element: ModuleTabs,
        childElement: Details,
        type: "XR",
        tabName: "details",
        permissions: [CONTENT_XR]
    },
    {
        path: "/dashboard/xr/assets/:uuid",
        element: ModuleTabs,
        childElement: UploadAssets,
        type: "XR",
        tabName: "assets",
        permissions: [CONTENT_XR, CONTENT_XR_ASSETS]
    },
    {
        path: "/dashboard/xr/tasklist/:uuid",
        element: ModuleTabs,
        childElement: Tasklist,
        type: "XR",
        tabName: "tasklist",
        permissions: [CONTENT_XR, CONTENT_XR_TASKS]
    },
    {
        path: "/dashboard/xr/quiz/:uuid",
        element: ModuleTabs,
        childElement: QuizPage,
        type: "XR",
        tabName: "quiz",
        permissions: [CONTENT_XR, CONTENT_XR_QUIZ]
    },
    {
        path: "/dashboard/xr/sop/:uuid",
        element: ModuleTabs,
        childElement: SopPage,
        type: "XR",
        tabName: "sop",
        permissions: [CONTENT_XR, CONTENT_XR_SOPS]
    },
    {
        path: "/dashboard/xr/criteria/:uuid",
        element: ModuleTabs,
        childElement: PassingCriteria,
        type: "XR",
        tabName: "criteria",
        permissions: [CONTENT_XR, CONTENT_XR_PASSING]
    },
    {
        path: "/dashboard/xr/video/:uuid",
        element: ModuleTabs,
        childElement: Videopage,
        type: "XR",
        tabName: "video",
        permissions: [CONTENT_XR]
    },
    {
        path: "/dashboard/xr/channels/:uuid",
        element: ModuleTabs,
        childElement: Channels,
        type: "XR",
        tabName: "channels",
        permissions: [CONTENT_XR]
    },
    {
        path: "/dashboard/xr/languages/:uuid",
        element: ModuleTabs,
        childElement: Languages,
        type: "XR",
        tabName: "languages",
        permissions: [CONTENT_XR]
    },
    {
        path: "/dashboard/xr/channels/select/:uuid",
        element: ModuleTabs,
        childElement: ChannelsSelect,
        type: "XR",
        tabName: "channels",
        permissions: [CONTENT_XR]
    },
    {
        path: "/dashboard/xr/deploy/:uuid/:id",
        element: ModuleTabs,
        childElement: DeployPage,
        type: "XR",
        tabName: "channels",
        permissions: [CONTENT_XR]
    },
    {
        path: "/dashboard/xr/review/details/:uuid",
        element: ModuleTabs,
        childElement: Details,
        type: "REVIEW",
        tabName: "details",
        permissions: [CONTENT_XR]
    },
    {
        path: "/dashboard/xr/review/assets/:uuid",
        element: ModuleTabs,
        childElement: UploadAssets,
        type: "REVIEW",
        tabName: "details",
        permissions: [CONTENT_XR, CONTENT_XR_ASSETS]
    },
    {
        path: "/dashboard/environments",
        element: ENVDashboard,
        permissions: [CONTENT_ENVIRONMENT]
    },

    {
        path: "/dashboard/environments/details/:uuid",
        element: ENVTabs,
        childElement: ENVDetails,
        tabName: "details",
        permissions: [CONTENT_ENVIRONMENT, CONTENT_ENVIRONMENT_CREATE]
    },
    {
        path: "/dashboard/environments/assets/:uuid",
        element: ENVTabs,
        childElement: ENVAssets,
        tabName: "assets",
        permissions: [CONTENT_ENVIRONMENT]
    },
    {
        path: "/dashboard/environments/content/:uuid",
        element: ENVTabs,
        childElement: ENVContent,
        tabName: "content",
        permissions: [CONTENT_ENVIRONMENT, CONTENT_DYNAMIC_CONTENT]
    },
    {
        path: "/dashboard/environments/channels/:uuid",
        element: ENVTabs,
        childElement: Channels,
        tabName: "channels",
        permissions: [CONTENT_ENVIRONMENT]
    },
    {
        path: "/dashboard/environments/channels/select/:uuid",
        element: ENVTabs,
        childElement: ChannelsSelect,
        tabName: "channels",
        permissions: [CONTENT_ENVIRONMENT]
    },
    {
        path: "/dashboard/environments/deploy/:uuid/:id",
        element: ENVTabs,
        childElement: DeployPage,
        tabName: "channels",
        permissions: [CONTENT_ENVIRONMENT]
    },
    {
        path: "/dashboard/environments/scenario/:uuid",
        element: ENVTabs,
        childElement: ScenarioBuilder,
        tabName: "scenario",
        permissions: [CONTENT_ENVIRONMENT]
    },
    {
        path: "/dashboard/environments/scenario/:uuid/edit/:moduleId",
        element: ENVTabs,
        childElement: AddDynamicModule,
        tabName: "scenario",
        permissions: [CONTENT_ENVIRONMENT]
    },
    {
        path: "/dashboard/3d/:id",
        element: AssetDashboard,
        permissions: [CONTENT_3D]
    },
    {
        path: "/dashboard/3d/:parentId/:id",
        element: AssetsChildDashboard,
        permissions: [CONTENT_3D]
    },
    {
        path: "/dashboard/3d/details/:uuid",
        element: AssetsTabs,
        childElement: AssetDetails,
        tabName: "details",
        permissions: [CONTENT_3D]
    },
    {
        path: "/dashboard/3d/review/details/:uuid",
        element: AssetsTabs,
        childElement: AssetDetails,
        tabName: "details",
        permissions: [CONTENT_3D]
    },
    {
        path: "/dashboard/3d/channels/:uuid",
        element: AssetsTabs,
        childElement: Channels,
        tabName: "channels",
        permissions: [CONTENT_3D]
    },
    {
        path: "/dashboard/3d/channels/select/:uuid",
        element: AssetsTabs,
        childElement: ChannelsSelect,
        tabName: "channels",
        permissions: [CONTENT_3D]
    },
    {
        path: "/dashboard/3d/deploy/:uuid/:id",
        element: AssetsTabs,
        childElement: DeployPage,
        tabName: "channels",
        permissions: [CONTENT_3D]
    },
    {
        path: "/dashboard/2d/lms",
        element: LMSDashboard,
        permissions: [CONTENT_2D]
    },
    {
        path: "/dashboard/2d/lms/details/:uuid",
        element: LMSDetailsPage,
        permissions: [CONTENT_2D]
    },
    {
        path: "/dashboard/2d/lms/subsection/details/:uuid",
        element: SubSectionDetails,
        permissions: [CONTENT_2D]
    },
    {
        path: "/dashboard/2d/lms/channels/select/:uuid",
        element: ChannelsSelect,
        permissions: [CONTENT_2D]
    },
    {
        path: "/ar/list",
        element: ArList,
        permissions: [CONTENT_AR]
    },
    {
        path: "/dashboard/ar/details/:moduleId",
        element: ARTabs,
        tabName: "details",
        childElement: ARModuleDetails,
        permissions: [CONTENT_AR, CONTENT_AR_CREATE]
    },
    {
        path: "/categories",
        element: CategoryMain,
        permissions: [CONTENT_CATEGORY]
    }
]

export default routesList;
